import { render } from "./PaymentHistoryCard.vue?vue&type=template&id=38286c19&scoped=true"
import script from "./PaymentHistoryCard.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryCard.vue?vue&type=script&lang=js"

import "./PaymentHistoryCard.vue?vue&type=style&index=0&id=38286c19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38286c19"]])

export default __exports__